import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { PdfFileService } from './../../services/pdf-file.service';
import { FileExportService } from './../../services/file-export.service';
import { PartnerDto } from './../../model/partner-dto';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { PurchaseOrderReportDto } from './../../model/purchase-order-report-dto';
import { AppSettingService } from './../../services/app-setting.service';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-purchase-order-report',
  templateUrl: './purchase-order-report.component.html',
  styleUrls: ['./purchase-order-report.component.css']
})
export class PurchaseOrderReportComponent implements OnInit {
  dateRange:string="";
  dateRangePoReport : string;
  count: number = 25;
  config: any;
  purchaseOrderReportArray : PurchaseOrderReportDto[];
  selectedPartnerPurchaseOrderReportArray : PurchaseOrderReportDto[];
  intialPurchaseOrderReportList : PurchaseOrderReportDto[];
  poReoprtListAllSelect  : PurchaseOrderReportDto[];
  loading : boolean;

  ispoDateSortCollapsedUpArrow: boolean;
  ispoDateSortCollapsedDownArrow: boolean;

  isOrderDateSortCollapsedUpArrow: boolean;
  isOrderDateSortCollapsedDownArrow: boolean;

  ispoNumberSortCollapsedUpArrow: boolean;
  ispoNumberSortCollapsedDownArrow: boolean;

  isaxaltaCartKeySortCollapsedUpArrow: boolean;
  isaxaltaCartKeySortCollapsedDownArrow: boolean;

  issupplierDocReferenceNumberSortCollapsedUpArrow: boolean;
  issupplierDocReferenceNumberSortCollapsedDownArrow: boolean;

  isbolDateSortCollapsedUpArrow: boolean;
  isbolDateSortCollapsedDownArrow: boolean;


  isinvoiceNumberSortCollapsedUpArrow: boolean;
  isinvoiceNumberSortCollapsedDownArrow: boolean;

  isdebitinvoiceNumberSortCollapsedUpArrow: boolean;
  isdebitinvoiceNumberSortCollapsedDownArrow: boolean;

  iscreditinvoiceNumberSortCollapsedUpArrow: boolean;
  iscreditinvoiceNumberSortCollapsedDownArrow: boolean;

  isdistributorPayerNumberSortCollapsedUpArrow: boolean;
  isdistributorPayerNumberSortCollapsedDownArrow: boolean;

  ismsoEntityNameSortCollapsedUpArrow: boolean;
  ismsoEntityNameSortCollapsedDownArrow: boolean;

  ismsoPayerAccountSortCollapsedUpArrow: boolean;
  ismsoPayerAccountSortCollapsedDownArrow: boolean;

  isPartnerNameSortCollapsedUpArrow: boolean;
  isPartnerNameSortCollapsedDownArrow: boolean;

  isrefCodeNameSortCollapsedUpArrow: boolean;
  isrefCodeNameSortCollapsedDownArrow: boolean;

  isshippedQtySortCollapsedUpArrow: boolean;
  isshippedQtySortCollapsedDownArrow: boolean;

  isorderedQtySortCollapsedUpArrow: boolean;
  isorderedQtySortCollapsedDownArrow: boolean;
  exportModal: string;
  exportList: string[] = ['Excel','PDF' ];
  partnerNameList : PartnerDto[];
  customerNameList : PartnerDto[];

  selectedAllRow: boolean;
  daterange ;
  selectedPurchaseOrderReport: any = [];
  partnerModal : string;
  customerModal : string;
  maxDate: moment.Moment;

  
  constructor(private httpClient : HttpclientService,public appSettingService: AppSettingService,
    private pipe: PoOrderByPipe,public fileExportService: FileExportService,public pdfFileService: PdfFileService,
    public excelFileService: ExcelFileService,public datepipe: DatePipe
  ) { 
    this.purchaseOrderReportArray = [];
    this.exportModal = this.exportList[0];
    this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };
  }

  ngOnInit() {
    this.partnerModal ="-1";
    this.customerModal ="-1";
    this.getPartnersName();
    this.getCustomersName();
    this.maxDate = moment().add(0, 'days');
    this.exportModal = this.appSettingService.exportList[0];
    
  }
  onChangeSelectedCustomer(){
    
    if(this.customerModal!="-1" ){
      console.log(" customer > "+this.customerModal);
      // this.partnerModal="-1";
      this.customerModal=this.customerModal;
      this.selectedPartnerPurchaseOrderReportArray=[]; 
      var len = this.intialPurchaseOrderReportList.length;
      var j =0;
      // this.customerModal = this.customerModal.toUpperCase();
      // const localCustomer  = this.customerModal;
      console.log("upper"+this.customerModal);
      
      for(let i = 0;i < len;i++) {
        if(this.customerModal === this.intialPurchaseOrderReportList[i].ediTpId){
          if(this.partnerModal != '-1'){
            if(this.partnerModal == this.intialPurchaseOrderReportList[i].partnerNumber){
              this.selectedPartnerPurchaseOrderReportArray[j] = this.intialPurchaseOrderReportList[i]
              j++;
            }
          }else{
            this.selectedPartnerPurchaseOrderReportArray[j] = this.intialPurchaseOrderReportList[i]
            j++;
          }
        }
      }
      this.purchaseOrderReportArray = this.selectedPartnerPurchaseOrderReportArray;
      }else if(this.customerModal === '-1'){
        if(this.partnerModal!="-1" ){
          this.onChangeSelectedPartner();
        }else{
         this.purchaseOrderReportArray = this.intialPurchaseOrderReportList;
        }
      }
    
  }
  pageChanged(event) {
    this.config.currentPage = event;
  }
  onChangeSelectedPartner(){

    if(this.partnerModal!="-1" ){
      console.log(" partner > "+this.partnerModal);
      // this.customerModal="-1";
      this.partnerModal=this.partnerModal;
    this.selectedPartnerPurchaseOrderReportArray=[]; 
    var len = this.intialPurchaseOrderReportList.length;
    
    var j =0;
    for(var i=0;i<len;i++){
      if(this.partnerModal == this.intialPurchaseOrderReportList[i].partnerNumber){
        if(this.customerModal !='-1'){
          if(this.customerModal === this.intialPurchaseOrderReportList[i].ediTpId){
            this.selectedPartnerPurchaseOrderReportArray[j]=this.intialPurchaseOrderReportList[i]
            j++;
          }
        }
        else{
          this.selectedPartnerPurchaseOrderReportArray[j]=this.intialPurchaseOrderReportList[i]
            j++;
        }
      }
    }
    this.purchaseOrderReportArray=this.selectedPartnerPurchaseOrderReportArray;
    }else if(this.partnerModal=="-1"){
      if(this.customerModal!="-1" ){
        this.onChangeSelectedCustomer();
      }else{
        this.purchaseOrderReportArray=this.intialPurchaseOrderReportList;
      }
    }
  }

  ChangeSortOrder(exportData) {
    this.exportModal = exportData;
  }

  modalPopup : boolean=false;
  modalPopupString: string;
  pressingOK(){
    this.modalPopup=false;
  }
  export() {
    if(this.purchaseOrderReportArray == null || this.purchaseOrderReportArray == undefined || this.purchaseOrderReportArray.length === 0){
      this.modalPopupString="No Data to Export";
      this.modalPopup=true;
      return;
    }
    
    let flag : boolean;
   
    if (this.fileExportService.selectedPurchaseOrderReportData.length === 0) {
      flag=true;
      this.poReoprtListAllSelect = [];
      this.purchaseOrderReportArray.forEach(pdto => {
        pdto.rowCheck = true;
        this.poReoprtListAllSelect.push(pdto);
      });
      this.purchaseOrderReportArray = this.poReoprtListAllSelect;
      this.fileExportService.selectedPurchaseOrderReportData = this.poReoprtListAllSelect;
    } 
      if (this.exportModal === 'PDF') {
        this.pdfFileService.exportPurchaseOrderReportTable('Purchase Order Report Table');
      } else if (this.exportModal === 'Excel') {
        this.selectedPurchaseOrderReport = [];
        this.fileExportService.selectedPurchaseOrderReportData.forEach(pdto => {
          if (pdto.rowCheck) {
            var orderedQtyStr;
            if(pdto.poDate == null || pdto.poDate == ""  || pdto.poDate == undefined){
              pdto.poDate="";
            }else{
              pdto.poDate = this.datepipe.transform(pdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
            }
            if(pdto.invoiceNumber == null || pdto.invoiceNumber == "" || pdto.invoiceNumber == undefined){
              pdto.invoiceNumber="";
            }
            if(pdto.distributorPayerNumber == null || pdto.distributorPayerNumber == "" || pdto.distributorPayerNumber == undefined){
              pdto.distributorPayerNumber="";
            }
            if(pdto.msoEntityName == null || pdto.msoEntityName == "" || pdto.msoEntityName == undefined){
              pdto.msoEntityName="";
            }
            if(pdto.msoPayerAccount == null || pdto.msoPayerAccount == "" || pdto.msoPayerAccount == undefined){
              pdto.msoPayerAccount="";
            }
            if(pdto.refCodeName == null || pdto.refCodeName == "" || pdto.refCodeName == undefined){
              pdto.refCodeName="";
            }
            if(pdto.orderedQty == null||pdto.orderedQty == undefined){
              orderedQtyStr="";
            }else{
              orderedQtyStr = pdto.orderedQty+"";
            }
            if(pdto.shippedQty== null || pdto.shippedQty== "" || pdto.shippedQty==  undefined){
              pdto.shippedQty="";
            }
            if(pdto.bolDate == null || pdto.bolDate == "" || pdto.bolDate == undefined){
              pdto.bolDate="";
            }else{
              pdto.bolDate = this.datepipe.transform(pdto.bolDate, this.appSettingService.globelDatePickerInUSAFormat) ;
            }
			if(pdto.creditInvoiceNumber == null || pdto.creditInvoiceNumber == "" || pdto.creditInvoiceNumber == undefined){
                pdto.creditInvoiceNumber = "";
            }
            if(pdto.debitInvoiceNumber == null || pdto.debitInvoiceNumber == "" || pdto.debitInvoiceNumber == undefined){
                pdto.debitInvoiceNumber = "";
            }            
			if(pdto.supplierDocReferenceNumber == null || pdto.supplierDocReferenceNumber == "" || pdto.supplierDocReferenceNumber ==  undefined){
              pdto.supplierDocReferenceNumber="";
            }
            if(pdto.axaltaCartKey == null || pdto.axaltaCartKey =="" || pdto.axaltaCartKey ==undefined){
              pdto.axaltaCartKey="";
            }
            if(pdto.poNumber == null ||pdto.poNumber == ""|| pdto.poNumber == undefined){
              pdto.poNumber="";
            }
            

            this.selectedPurchaseOrderReport.push({
              'PO Date': `` + `${pdto.poDate}`,'PO#': `` + `${pdto.poNumber}`, AxaltaCartKey: `${pdto.axaltaCartKey}`,'BoL#': `${pdto.supplierDocReferenceNumber}`,
              'BoL Date': `${pdto.bolDate }`,'Credit Invoice#': `${pdto.creditInvoiceNumber}`, 'Debit Invoice#': `${pdto.debitInvoiceNumber}`, 'Distributor Payer#': `${pdto.distributorPayerNumber}`,  'Partner Name': `${pdto.partnerName}`, 'MSO Entity Name':  `${pdto.msoEntityName}`,
              'MSO Payer Account': `${pdto.msoPayerAccount}`,Status: `${pdto.refCodeName}`,
              'Order Quantity': orderedQtyStr, 'Shipped Quantity': `${pdto.shippedQty}`, 
            });
          }
        });
        this.excelFileService.exportPurchaseOrderReportTableExcel(this.selectedPurchaseOrderReport, 'Purchase Order Report Table');
      }
      if(flag){
        this.poReoprtListAllSelect = [];
        this.purchaseOrderReportArray.forEach(pdto => {
          pdto.rowCheck = false;
          this.poReoprtListAllSelect.push(pdto);
        });
        this.purchaseOrderReportArray = this.poReoprtListAllSelect;
        this.fileExportService.selectedPurchaseOrderReportData = [];
      }
  }

  changerecordperpage(value) {
    
        this.config.itemsPerPage = value;
        this.count = value;
      }

  onSelect(selectedItem: any, values: any) {
    let checkStaus = true;
    if (values.currentTarget.checked) {

      this.fileExportService.selectedPurchaseOrderReportData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedPurchaseOrderReportData = this.fileExportService.selectedPurchaseOrderReportData.filter(obj => obj !== selectedItem);
     
    }

    if(this.fileExportService.selectedPurchaseOrderReportData.length === this.poReoprtListAllSelect.length){
      this.selectedAllRow = true;
    }else{ 
      this.selectedAllRow = false;
    }
    

}
  onSelectAllCust(values: any) {
    
        this.poReoprtListAllSelect = [];
        if (values.currentTarget.checked) {
          this.purchaseOrderReportArray.forEach(pdto => {
            pdto.rowCheck = true;
            this.poReoprtListAllSelect.push(pdto);
          });
          this.purchaseOrderReportArray = this.poReoprtListAllSelect;
          this.fileExportService.selectedPurchaseOrderReportData = this.poReoprtListAllSelect;
        } else {
          this.purchaseOrderReportArray.forEach(pdto => {
            console.log('...' + pdto.rowCheck);
            pdto.rowCheck = false;
            this.poReoprtListAllSelect.push(pdto);
          });
          this.purchaseOrderReportArray = this.poReoprtListAllSelect;
          this.fileExportService.selectedPurchaseOrderReportData = [];
        }
    
      }
  getCustomersName(){
    this.loading=true;
    this.httpClient.getCustomersName().subscribe(
      data => {
        
        this.customerNameList=data;
        
        this.loading=false;
      }
    )
  }

  getPartnersName(){
    this.loading=true;
    this.httpClient.getPartnersName().subscribe(
      data => {
        
        this.partnerNameList=data;
        
        this.loading=false;
      }
    )
  }
  getPurchaseOrderReport(){
    var startDate = this.daterange.start.format('YYYY-MM-DD');
    var endDate = this.daterange.end.format('YYYY-MM-DD');
    this.loading=true;
    
    this.partnerModal ="-1";
    this.customerModal ="-1";

    this.httpClient.getPurchaseOrderReport(startDate, endDate).subscribe(
      data => {
        
        this.purchaseOrderReportArray=data;
        this.intialPurchaseOrderReportList=data;
        this.loading=false;
      }
    )
  } 

  initialSortValue() {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
     this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
     this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
     this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
  }
  

  sortArry: PurchaseOrderReportDto[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.intialPurchaseOrderReportList=this.purchaseOrderReportArray;
    if (propertyName === 'poDate' ) {
      this.ispoNumberSortCollapsedUpArrow=true;
      this.ispoNumberSortCollapsedDownArrow=true;
      this.isaxaltaCartKeySortCollapsedUpArrow=true;
      this.isaxaltaCartKeySortCollapsedDownArrow=true;
      this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
      this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
      this.isbolDateSortCollapsedUpArrow=true;
      this.isbolDateSortCollapsedDownArrow=true;
      this.isinvoiceNumberSortCollapsedUpArrow=true;
      this.isinvoiceNumberSortCollapsedDownArrow=true;
      this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
      this.isdistributorPayerNumberSortCollapsedUpArrow=true;
      this.isdistributorPayerNumberSortCollapsedDownArrow=true;
      this.ismsoEntityNameSortCollapsedUpArrow=true;
      this.ismsoEntityNameSortCollapsedDownArrow=true;
      this.ismsoPayerAccountSortCollapsedUpArrow=true;
      this.ismsoPayerAccountSortCollapsedDownArrow=true;
      this.isPartnerNameSortCollapsedUpArrow=true;
      this.isPartnerNameSortCollapsedDownArrow=true;
      this.isrefCodeNameSortCollapsedUpArrow=true;
      this.isrefCodeNameSortCollapsedDownArrow=true;
      this.isshippedQtySortCollapsedUpArrow=true;
      this.isshippedQtySortCollapsedDownArrow=true;
      this.isorderedQtySortCollapsedUpArrow=true;
      this.isorderedQtySortCollapsedDownArrow=true;
     if (upDown) {
   this.sortArry = [];
   this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, upDown);
   this.purchaseOrderReportArray = [];
   this.purchaseOrderReportArray = this.sortArry;
   this.ispoDateSortCollapsedUpArrow = !this.ispoDateSortCollapsedUpArrow;
   this.ispoDateSortCollapsedDownArrow = true;
} else {
 this.sortArry = [];
 this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, upDown);
 this.purchaseOrderReportArray = [];
 this.purchaseOrderReportArray = this.sortArry;
 this.ispoDateSortCollapsedDownArrow = !this.ispoDateSortCollapsedDownArrow;
 this.ispoDateSortCollapsedUpArrow = true;
}
 } 
    else if (propertyName === 'poNumber' ) {
      this.ispoDateSortCollapsedUpArrow=true;
      this.ispoDateSortCollapsedDownArrow=true;
       this.isaxaltaCartKeySortCollapsedUpArrow=true;
       this.isaxaltaCartKeySortCollapsedDownArrow=true;
       this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
       this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
       this.isbolDateSortCollapsedUpArrow=true;
       this.isbolDateSortCollapsedDownArrow=true;
       this.isinvoiceNumberSortCollapsedUpArrow=true;
       this.isinvoiceNumberSortCollapsedDownArrow=true;
       this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
       this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
       this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
       this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
       this.isdistributorPayerNumberSortCollapsedUpArrow=true;
       this.isdistributorPayerNumberSortCollapsedDownArrow=true;
       this.ismsoEntityNameSortCollapsedUpArrow=true;
       this.ismsoEntityNameSortCollapsedDownArrow=true;
       this.ismsoPayerAccountSortCollapsedUpArrow=true;
       this.ismsoPayerAccountSortCollapsedDownArrow=true;
       this.isPartnerNameSortCollapsedUpArrow=true;
       this.isPartnerNameSortCollapsedDownArrow=true;
       this.isrefCodeNameSortCollapsedUpArrow=true;
       this.isrefCodeNameSortCollapsedDownArrow=true;
       this.isshippedQtySortCollapsedUpArrow=true;
       this.isshippedQtySortCollapsedDownArrow=true;
       this.isorderedQtySortCollapsedUpArrow=true;
       this.isorderedQtySortCollapsedDownArrow=true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, upDown);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.ispoNumberSortCollapsedUpArrow = !this.ispoNumberSortCollapsedUpArrow;
    this.ispoNumberSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, upDown);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.ispoNumberSortCollapsedDownArrow = !this.ispoNumberSortCollapsedDownArrow;
  this.ispoNumberSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'axaltaCartKey' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
     this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
     this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
     this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.isaxaltaCartKeySortCollapsedUpArrow = !this.isaxaltaCartKeySortCollapsedUpArrow;
    this.isaxaltaCartKeySortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isaxaltaCartKeySortCollapsedDownArrow = !this.isaxaltaCartKeySortCollapsedDownArrow;
  this.isaxaltaCartKeySortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'supplierDocReferenceNumber' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.issupplierDocReferenceNumberSortCollapsedUpArrow = !this.issupplierDocReferenceNumberSortCollapsedUpArrow;
    this.issupplierDocReferenceNumberSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.issupplierDocReferenceNumberSortCollapsedDownArrow = !this.issupplierDocReferenceNumberSortCollapsedDownArrow;
  this.issupplierDocReferenceNumberSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'bolDate' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.isbolDateSortCollapsedUpArrow = !this.isbolDateSortCollapsedUpArrow;
    this.isbolDateSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isbolDateSortCollapsedDownArrow = !this.isbolDateSortCollapsedDownArrow;
  this.isbolDateSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'invoiceNumber' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
     this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
     this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
     this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.isinvoiceNumberSortCollapsedUpArrow = !this.isinvoiceNumberSortCollapsedUpArrow;
    this.isinvoiceNumberSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isinvoiceNumberSortCollapsedDownArrow = !this.isinvoiceNumberSortCollapsedDownArrow;
  this.isinvoiceNumberSortCollapsedUpArrow = true;
} 
} else if (propertyName === 'debitInvoiceNumber' ) {
  this.ispoDateSortCollapsedUpArrow=true;
  this.ispoDateSortCollapsedDownArrow=true;
  this.ispoNumberSortCollapsedUpArrow=true;
  this.ispoNumberSortCollapsedDownArrow=true;
   this.isaxaltaCartKeySortCollapsedUpArrow=true;
   this.isaxaltaCartKeySortCollapsedDownArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
   this.isinvoiceNumberSortCollapsedUpArrow=true;
   this.isinvoiceNumberSortCollapsedDownArrow=true;
   this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
   this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
   this.isbolDateSortCollapsedUpArrow=true;
   this.isbolDateSortCollapsedDownArrow=true;
   this.isdistributorPayerNumberSortCollapsedUpArrow=true;
   this.isdistributorPayerNumberSortCollapsedDownArrow=true;
   this.ismsoEntityNameSortCollapsedUpArrow=true;
   this.ismsoEntityNameSortCollapsedDownArrow=true;
   this.ismsoPayerAccountSortCollapsedUpArrow=true;
   this.ismsoPayerAccountSortCollapsedDownArrow=true;
   this.isPartnerNameSortCollapsedUpArrow=true;
   this.isPartnerNameSortCollapsedDownArrow=true;
   this.isrefCodeNameSortCollapsedUpArrow=true;
   this.isrefCodeNameSortCollapsedDownArrow=true;
   this.isshippedQtySortCollapsedUpArrow=true;
   this.isshippedQtySortCollapsedDownArrow=true;
   this.isorderedQtySortCollapsedUpArrow=true;
   this.isorderedQtySortCollapsedDownArrow=true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
  console.log("property"+propertyName);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isdebitinvoiceNumberSortCollapsedUpArrow = !this.isdebitinvoiceNumberSortCollapsedUpArrow;
  this.isdebitinvoiceNumberSortCollapsedDownArrow = true;
} else {
this.sortArry = []; 
this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
this.purchaseOrderReportArray = [];
this.purchaseOrderReportArray = this.sortArry;
this.isdebitinvoiceNumberSortCollapsedDownArrow = !this.isdebitinvoiceNumberSortCollapsedDownArrow;
this.isdebitinvoiceNumberSortCollapsedUpArrow = true;
}
} else if (propertyName === 'creditInvoiceNumber' ) {
  this.ispoDateSortCollapsedUpArrow=true;
  this.ispoDateSortCollapsedDownArrow=true;
  this.ispoNumberSortCollapsedUpArrow=true;
  this.ispoNumberSortCollapsedDownArrow=true;
   this.isaxaltaCartKeySortCollapsedUpArrow=true;
   this.isaxaltaCartKeySortCollapsedDownArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
   this.isinvoiceNumberSortCollapsedUpArrow=true;
   this.isinvoiceNumberSortCollapsedDownArrow=true;
   this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
   this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
   this.isbolDateSortCollapsedUpArrow=true;
   this.isbolDateSortCollapsedDownArrow=true;
   this.isdistributorPayerNumberSortCollapsedUpArrow=true;
   this.isdistributorPayerNumberSortCollapsedDownArrow=true;
   this.ismsoEntityNameSortCollapsedUpArrow=true;
   this.ismsoEntityNameSortCollapsedDownArrow=true;
   this.ismsoPayerAccountSortCollapsedUpArrow=true;
   this.ismsoPayerAccountSortCollapsedDownArrow=true;
   this.isPartnerNameSortCollapsedUpArrow=true;
   this.isPartnerNameSortCollapsedDownArrow=true;
   this.isrefCodeNameSortCollapsedUpArrow=true;
   this.isrefCodeNameSortCollapsedDownArrow=true;
   this.isshippedQtySortCollapsedUpArrow=true;
   this.isshippedQtySortCollapsedDownArrow=true;
   this.isorderedQtySortCollapsedUpArrow=true;
   this.isorderedQtySortCollapsedDownArrow=true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
  console.log("property"+propertyName);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.iscreditinvoiceNumberSortCollapsedUpArrow = !this.iscreditinvoiceNumberSortCollapsedUpArrow;
  this.iscreditinvoiceNumberSortCollapsedDownArrow = true;
} else {
this.sortArry = []; 
this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
this.purchaseOrderReportArray = [];
this.purchaseOrderReportArray = this.sortArry;
this.iscreditinvoiceNumberSortCollapsedDownArrow = !this.iscreditinvoiceNumberSortCollapsedDownArrow;
this.iscreditinvoiceNumberSortCollapsedUpArrow = true;
} 
   } else if (propertyName === 'distributorPayerNumber' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.isdistributorPayerNumberSortCollapsedUpArrow = !this.isdistributorPayerNumberSortCollapsedUpArrow;
    this.isdistributorPayerNumberSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isdistributorPayerNumberSortCollapsedDownArrow = !this.isdistributorPayerNumberSortCollapsedDownArrow;
  this.isdistributorPayerNumberSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'msoEntityName' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoPayerAccountSortCollapsedUpArrow=true;
     this.ismsoPayerAccountSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.ismsoEntityNameSortCollapsedUpArrow = !this.ismsoEntityNameSortCollapsedUpArrow;
    this.ismsoEntityNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.ismsoEntityNameSortCollapsedDownArrow = !this.ismsoEntityNameSortCollapsedDownArrow;
  this.ismsoEntityNameSortCollapsedUpArrow = true;
} 
  } 
  else if (propertyName === 'msoPayerAccount' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
     this.isaxaltaCartKeySortCollapsedUpArrow=true;
     this.isaxaltaCartKeySortCollapsedDownArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
     this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
     this.isbolDateSortCollapsedUpArrow=true;
     this.isbolDateSortCollapsedDownArrow=true;
     this.isinvoiceNumberSortCollapsedUpArrow=true;
     this.isinvoiceNumberSortCollapsedDownArrow=true;
     this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
     this.isdistributorPayerNumberSortCollapsedUpArrow=true;
     this.isdistributorPayerNumberSortCollapsedDownArrow=true;
     this.ismsoEntityNameSortCollapsedUpArrow=true;
     this.ismsoEntityNameSortCollapsedDownArrow=true;
     this.isPartnerNameSortCollapsedUpArrow=true;
     this.isPartnerNameSortCollapsedDownArrow=true;
     this.isrefCodeNameSortCollapsedUpArrow=true;
     this.isrefCodeNameSortCollapsedDownArrow=true;
     this.isshippedQtySortCollapsedUpArrow=true;
     this.isshippedQtySortCollapsedDownArrow=true;
     this.isorderedQtySortCollapsedUpArrow=true;
     this.isorderedQtySortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
      console.log("property"+propertyName);
      this.purchaseOrderReportArray = [];
      this.purchaseOrderReportArray = this.sortArry;
      this.ismsoPayerAccountSortCollapsedUpArrow = !this.ismsoPayerAccountSortCollapsedUpArrow;
      this.ismsoPayerAccountSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
    this.purchaseOrderReportArray = [];
    this.purchaseOrderReportArray = this.sortArry;
    this.ismsoPayerAccountSortCollapsedDownArrow = !this.ismsoPayerAccountSortCollapsedDownArrow;
    this.ismsoPayerAccountSortCollapsedUpArrow = true;
  } 
    }
    else if (propertyName === 'partnerName' ) {
      this.ispoDateSortCollapsedUpArrow=true;
      this.ispoDateSortCollapsedDownArrow=true;
      this.ispoNumberSortCollapsedUpArrow=true;
      this.ispoNumberSortCollapsedDownArrow=true;
       this.isaxaltaCartKeySortCollapsedUpArrow=true;
       this.isaxaltaCartKeySortCollapsedDownArrow=true;
       this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
       this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
       this.isbolDateSortCollapsedUpArrow=true;
       this.isbolDateSortCollapsedDownArrow=true;
       this.isinvoiceNumberSortCollapsedUpArrow=true;
       this.isinvoiceNumberSortCollapsedDownArrow=true;
       this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
      this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
      this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
      this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
       this.isdistributorPayerNumberSortCollapsedUpArrow=true;
       this.isdistributorPayerNumberSortCollapsedDownArrow=true;
       this.ismsoEntityNameSortCollapsedUpArrow=true;
       this.ismsoEntityNameSortCollapsedDownArrow=true;
       this.ismsoPayerAccountSortCollapsedUpArrow=true;
       this.ismsoPayerAccountSortCollapsedDownArrow=true;
       this.isrefCodeNameSortCollapsedUpArrow=true;
       this.isrefCodeNameSortCollapsedDownArrow=true;
       this.isshippedQtySortCollapsedUpArrow=true;
       this.isshippedQtySortCollapsedDownArrow=true;
       this.isorderedQtySortCollapsedUpArrow=true;
       this.isorderedQtySortCollapsedDownArrow=true;
        if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
        console.log("property"+propertyName);
        this.purchaseOrderReportArray = [];
        this.purchaseOrderReportArray = this.sortArry;
        this.isPartnerNameSortCollapsedUpArrow = !this.isPartnerNameSortCollapsedUpArrow;
        this.isPartnerNameSortCollapsedDownArrow = true;
    } else {
      this.sortArry = []; 
      this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
      this.purchaseOrderReportArray = [];
      this.purchaseOrderReportArray = this.sortArry;
      this.isPartnerNameSortCollapsedDownArrow = !this.isPartnerNameSortCollapsedDownArrow;
      this.isPartnerNameSortCollapsedUpArrow = true;
    } 
      }
      
else if (propertyName === 'refCodeName' ) {
  this.ispoDateSortCollapsedUpArrow=true;
  this.ispoDateSortCollapsedDownArrow=true;
  this.ispoNumberSortCollapsedUpArrow=true;
  this.ispoNumberSortCollapsedDownArrow=true;
   this.isaxaltaCartKeySortCollapsedUpArrow=true;
   this.isaxaltaCartKeySortCollapsedDownArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
   this.isbolDateSortCollapsedUpArrow=true;
   this.isbolDateSortCollapsedDownArrow=true;
   this.isinvoiceNumberSortCollapsedUpArrow=true;
   this.isinvoiceNumberSortCollapsedDownArrow=true;
   this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
   this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
   this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
   this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
   this.isdistributorPayerNumberSortCollapsedUpArrow=true;
   this.isdistributorPayerNumberSortCollapsedDownArrow=true;
   this.ismsoEntityNameSortCollapsedUpArrow=true;
   this.ismsoEntityNameSortCollapsedDownArrow=true;
   this.ismsoPayerAccountSortCollapsedUpArrow=true;
   this.ismsoPayerAccountSortCollapsedDownArrow=true;
   this.isPartnerNameSortCollapsedUpArrow=true;
   this.isPartnerNameSortCollapsedDownArrow=true;
   this.isshippedQtySortCollapsedUpArrow=true;
   this.isshippedQtySortCollapsedDownArrow=true;
   this.isorderedQtySortCollapsedUpArrow=true;
   this.isorderedQtySortCollapsedDownArrow=true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
  console.log("property"+propertyName);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isrefCodeNameSortCollapsedUpArrow = !this.isrefCodeNameSortCollapsedUpArrow;
  this.isrefCodeNameSortCollapsedDownArrow = true;
} else {
this.sortArry = []; 
this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
this.purchaseOrderReportArray = [];
this.purchaseOrderReportArray = this.sortArry;
this.isrefCodeNameSortCollapsedDownArrow = !this.isrefCodeNameSortCollapsedDownArrow;
this.isrefCodeNameSortCollapsedUpArrow = true;
} 
}
else if (propertyName === 'shippedQty' ) {
  this.ispoDateSortCollapsedUpArrow=true;
  this.ispoDateSortCollapsedDownArrow=true;
  this.ispoNumberSortCollapsedUpArrow=true;
  this.ispoNumberSortCollapsedDownArrow=true;
   this.isaxaltaCartKeySortCollapsedUpArrow=true;
   this.isaxaltaCartKeySortCollapsedDownArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
   this.isbolDateSortCollapsedUpArrow=true;
   this.isbolDateSortCollapsedDownArrow=true;
   this.isinvoiceNumberSortCollapsedUpArrow=true;
   this.isinvoiceNumberSortCollapsedDownArrow=true;
   this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
   this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
   this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
   this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
   this.isdistributorPayerNumberSortCollapsedUpArrow=true;
   this.isdistributorPayerNumberSortCollapsedDownArrow=true;
   this.ismsoEntityNameSortCollapsedUpArrow=true;
   this.ismsoEntityNameSortCollapsedDownArrow=true;
   this.ismsoPayerAccountSortCollapsedUpArrow=true;
   this.ismsoPayerAccountSortCollapsedDownArrow=true;
   this.isPartnerNameSortCollapsedUpArrow=true;
   this.isPartnerNameSortCollapsedDownArrow=true;
   this.isrefCodeNameSortCollapsedUpArrow=true;
   this.isrefCodeNameSortCollapsedDownArrow=true;
   this.isorderedQtySortCollapsedUpArrow=true;
   this.isorderedQtySortCollapsedDownArrow=true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
  console.log("property"+propertyName);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isshippedQtySortCollapsedUpArrow = !this.isshippedQtySortCollapsedUpArrow;
  this.isshippedQtySortCollapsedDownArrow = true;
} else {
this.sortArry = []; 
this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
this.purchaseOrderReportArray = [];
this.purchaseOrderReportArray = this.sortArry;
this.isshippedQtySortCollapsedDownArrow = !this.isshippedQtySortCollapsedDownArrow;
this.isshippedQtySortCollapsedUpArrow = true;
} 
}
else if (propertyName === 'orderedQty' ) {
  this.ispoDateSortCollapsedUpArrow=true;
  this.ispoDateSortCollapsedDownArrow=true;
  this.ispoNumberSortCollapsedUpArrow=true;
  this.ispoNumberSortCollapsedDownArrow=true;
   this.isaxaltaCartKeySortCollapsedUpArrow=true;
   this.isaxaltaCartKeySortCollapsedDownArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedUpArrow=true;
   this.issupplierDocReferenceNumberSortCollapsedDownArrow=true;
   this.isbolDateSortCollapsedUpArrow=true;
   this.isbolDateSortCollapsedDownArrow=true;
   this.isinvoiceNumberSortCollapsedUpArrow=true;
   this.isdebitinvoiceNumberSortCollapsedUpArrow=true;
   this.iscreditinvoiceNumberSortCollapsedUpArrow=true;
   this.isinvoiceNumberSortCollapsedDownArrow=true;
   this.isdebitinvoiceNumberSortCollapsedDownArrow=true;
   this.iscreditinvoiceNumberSortCollapsedDownArrow=true;
   this.isdistributorPayerNumberSortCollapsedUpArrow=true;
   this.isdistributorPayerNumberSortCollapsedDownArrow=true;
   this.ismsoEntityNameSortCollapsedUpArrow=true;
   this.ismsoEntityNameSortCollapsedDownArrow=true;
   this.ismsoPayerAccountSortCollapsedUpArrow=true;
   this.ismsoPayerAccountSortCollapsedDownArrow=true;
   this.isPartnerNameSortCollapsedUpArrow=true;
   this.isPartnerNameSortCollapsedDownArrow=true;
   this.isrefCodeNameSortCollapsedUpArrow=true;
   this.isrefCodeNameSortCollapsedDownArrow=true;
   this.isshippedQtySortCollapsedUpArrow=true;
   this.isshippedQtySortCollapsedDownArrow=true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, true);
  console.log("property"+propertyName);
  this.purchaseOrderReportArray = [];
  this.purchaseOrderReportArray = this.sortArry;
  this.isorderedQtySortCollapsedUpArrow = !this.isorderedQtySortCollapsedUpArrow;
  this.isorderedQtySortCollapsedDownArrow = true;
} else {
this.sortArry = []; 
this.sortArry = this.pipe.transform(this.intialPurchaseOrderReportList, propertyName, false);
this.purchaseOrderReportArray = [];
this.purchaseOrderReportArray = this.sortArry;
this.isorderedQtySortCollapsedDownArrow = !this.isorderedQtySortCollapsedDownArrow;
this.isorderedQtySortCollapsedUpArrow = true;
} 
}

}    

}
